import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class LoginSubjectRoleLinkQueryCriteriaClass extends BaseCriteriaModel {
  app_subject_guid?: Optional<string> = Optional.empty();
  app_mst_role_guid?: Optional<string> = Optional.empty();
}

export class LoginSubjectRoleLinkCriteriaModelQuery {
  query = '';

  constructor(loginSubjectRoleLinkCriteriaModel: LoginSubjectRoleLinkQueryCriteriaClass) {

    if (!loginSubjectRoleLinkCriteriaModel) {
      return;
    }

    this.query += loginSubjectRoleLinkCriteriaModel.app_subject_guid.filter(x => x !== '').map(x => '&app_subject_guid=' + x).orElse('');
    this.query += loginSubjectRoleLinkCriteriaModel.app_mst_role_guid.filter(x => x !== '').map(x => '&app_mst_role_guid=' + x).orElse('');

    this.query += '&status=' + loginSubjectRoleLinkCriteriaModel.status;
    this.query += '&orderBy=' + loginSubjectRoleLinkCriteriaModel.orderBy;
    this.query += '&order=' + loginSubjectRoleLinkCriteriaModel.order;
    this.query += '&offset=' + loginSubjectRoleLinkCriteriaModel.offset + '&limit=' + loginSubjectRoleLinkCriteriaModel.limit;
  }
}
